import APIService from "@utils/apiService";
import _ from "lodash";
class Service {
  config: any;
  constructor(config: any) {
    this.config = config;
  }

  async send(query: any) {
    return await APIService.post(`/api/contacts`, { body: query });
  }
}
const Model = new Service({});

export default Model;
